// Bắt `beforeinstallprompt` TOÀN CỤC ngay khi app khởi động (import trong index.js trước
// render). Vì sao: người dùng luôn vào từ màn login; Chrome có thể bắn sự kiện ngay lúc đó
// (chỉ bắn MỘT lần mỗi lần tải trang). Nếu chỉ nghe trong InstallApp (mount ở /owner) thì
// chuyển trang bằng SPA không reload sẽ LỠ sự kiện → nút rơi về hướng dẫn tay.
// Lưu event ở module state; InstallApp đọc lúc mount + subscribe để cập nhật.
let deferredPrompt = null;
const listeners = new Set();

const notify = () => {
  listeners.forEach((cb) => {
    try {
      cb(deferredPrompt);
    } catch (e) {}
  });
};

export const getDeferredPrompt = () => deferredPrompt;

// Trả về hàm huỷ đăng ký.
export const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

// Sự kiện chỉ dùng được MỘT lần — prompt() xong phải bỏ.
export const clearDeferredPrompt = () => {
  deferredPrompt = null;
  notify();
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Chặn thanh nhắc cài mặc định của Chrome để tự chọn thời điểm mời.
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });
}
